import { Component, OnInit } from '@angular/core';
import { DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { CedProductService } from 'app/management/ced-products/ced-product.service';
import { CedProductModel } from 'app/management/ced-products/models/ced-product.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { purshaseService } from '../purshase.service';
import { SaleServiceDetailsComponent } from '../sale-service-details/sale-service-details.component';
import { serviceModel } from '../service-model';

@Component({
  selector: 'app-sales-service-list',
  templateUrl: './sales-service-list.component.html',
  styleUrls: ['./sales-service-list.component.scss']
})
export class SalesServiceListComponent implements OnInit {
  public selectedSaleService: CedProductModel = null;
  salesService: CedProductModel[];
  private _subject$: Subject<boolean> = new Subject();
  constructor(
    private dialogService: DialogService,
    private saleService: CedProductService
  ) { }

  ngOnInit() {
    this.getSalesService();
  }

  getSalesService(){
    this.saleService
    .getProductByClassification()
    .pipe(takeUntil(this._subject$))
    .subscribe((data:any) => {
      this.salesService = data;
    });
  }

  getServiceProductCodes(Service){
    let codes = Service.services.map(x=>x.itmLongName);
      return codes;
  }

  openDetails() { 
    if(this.selectedSaleService != null)
    this.saleService
          .getOneById(this.selectedSaleService.prdId)
          .pipe(takeUntil(this._subject$))
          .subscribe((data : any) => {
            this.selectedSaleService = data;
            this.openDialog(this.selectedSaleService);
            this.selectedSaleService = null;
          });     
  }

  onCellClick($event) {
    this.selectedSaleService = $event.dataItem
  } 
  openDialog(selectedSaleService){
    const dialogRef = this.dialogService.open({
      minWidth: "700px",
      content: SaleServiceDetailsComponent,
    });
    dialogRef.content.instance.selectedSaleService = selectedSaleService;
    dialogRef.result.subscribe((r:any) => {
      if ((r instanceof DialogCloseResult)!= null) {
         this.getSalesService();
      }
      this.selectedSaleService = null;
    });
  }
}
